import React, { useState } from 'react';
import { Box, IconButton, Modal } from '@mui/material';
import CloseIcon from "@mui/icons-material/Close";
import { DateRange } from 'react-date-range';
import { useTranslation } from 'react-i18next';
import { useThemeContext } from '../../Context/ThemeContext';
import { DARKCOLORS, LIGHTCOLORS } from '../../Utils/constants';
import dayjs from 'dayjs';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import '../../Styles/daterange-responsive.css';

const ExportDateRangeModal = ({ open, onClose, onExport, title, exportLabel, cancelLabel }) => {
    const { t } = useTranslation();
    const { mode } = useThemeContext();

    const btnColor = mode === 'dark' ? DARKCOLORS.Secondary500 : LIGHTCOLORS.Secondary500;
    const blueColor = mode === 'dark' ? DARKCOLORS.Primary500 : LIGHTCOLORS.Primary500;
    const calendarBg = mode === 'dark' ? DARKCOLORS.GreyScale10 : LIGHTCOLORS.GreyScale10;

    const [dateRange, setDateRange] = useState([
        {
            startDate: dayjs().startOf("month").toDate(),
            endDate: dayjs().toDate(),
            key: 'selection',
        },
    ]);

    const handleDateChange = (item) => setDateRange([item.selection]);

    return (
        <Modal open={open} onClose={onClose} aria-labelledby="export-modal-title">
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: { xs: '95%', sm: '400px' },
                    maxHeight: '90vh',
                    overflow: 'auto',
                    bgcolor: 'background.paper',
                    borderRadius: '12px',
                    boxShadow: 24,
                    p: 2.5,
                    "@media (max-width: 410px)": {
                        p: 1.5,
                    },
                }}
            >
                {/* Header */}
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
                    <h2 className='addmachine-text-heading1' style={{ margin: "0px" }}>
                        {title || t('inventory.exportTransactions', 'Export Transactions')}
                    </h2>
                    <IconButton sx={{ p: 0 }} onClick={onClose}>
                        <CloseIcon />
                    </IconButton>
                </Box>

                {/* Date Range Picker */}
                <Box
                    className={mode === 'dark' ? 'dark-mode' : ''}
                    sx={{
                        background: calendarBg,
                        borderRadius: '12px',
                        display: 'flex',
                        flexDirection: 'column',
                        mb: 3,
                        overflow: 'hidden',
                        width: '100%',
                    }}
                >
                    <DateRange
                        editableDateInputs={true}
                        onChange={handleDateChange}
                        moveRangeOnFirstSelection={false}
                        ranges={dateRange}
                        maxDate={new Date()}
                        style={{
                            borderRadius: '12px',
                            padding: '8px',
                        }}
                    />
                </Box>

                {/* Action Buttons */}
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: '1.5rem' }}>
                    <button
                        type="button"
                        style={{ color: blueColor, borderColor: blueColor }}
                        className='cancel-btn'
                        onClick={onClose}
                    >
                        {cancelLabel || t('membershipCards.cancel')}
                    </button>
                    <button
                        type="button"
                        onClick={() => onExport(dateRange)}
                        style={{ background: btnColor, color: "#000" }}
                        className='save-btn'
                    >
                        {exportLabel || t('membershipCards.export')}
                    </button>
                </Box>
            </Box>
        </Modal>
    );
};

export default ExportDateRangeModal;
